
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manfred-daily-companies",
      function () {
        return require("private-next-pages/manfred-daily-companies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manfred-daily-companies"])
      });
    }
  